<template>
<div class="chapter">
<div class="inner_page">
<div class="acknowledgments" id="ack">
<h2 class="chapter"><a id="pagevii"></a>ACKNOWLEDGMENTS</h2>
<p class="nonindent">I’d like to thank Mary Lace for reading this as it was being written, and Emmet O’Brien, David Goldfarb, Janet M. Kegg, Sherwood Smith, Clark E. Myers, Naomi Kritzer, Alison Scott, Jennifer Arnott, Naomi Libicki, Madeleine Kelly, Lila Garrott, Melissa McDowell, Laura Tennenhaus, Mary Ellen Curtin, Sylvia Rachel Hunter, Mary Kay Kare, Bob Webber, Rivka Wald, and Anne Gwin for reading it when it was done.</p>
<p class="indent">I’d like to thank my father-in-law, Tony O’Brien, for rescuing 1,500 words from the hard drive of my deceased laptop, Caliban. (Always back up!) Grande Bibliothèque du Québec, Fraser-Hickson Library, Cardiff Central Library, and the Montreal library system were all generous with books for research. Of all the books I used, I’d most especially like to mention the work of the biographer Anne De Courcy. I couldn’t have written this without <em>1939: The Last Season,</em> but all of her books have been reliable, readable, and so relevant she couldn’t have done better if she were my personal researcher.</p>
<p class="indent">Emmet O’Brien and Sasha Walton put up with me while I was writing, even on days when dinner was late or forgotten altogether. Alter Reiss helped immeasurably with depressing statistics, odd facts, seder details, and general encouragement.</p>
<p class="indent">My LiveJournal correspondents provided useful corroboration, information, and support (<a class="pubhlink" href="http://papersky.livejournal.com" target="_blank">papersky.livejournal.com</a>). Zev Sero gave me one perfect comment, which appears in <a class="hlink" href="#/OEBPS/9781429954631_epub_c25_r1.htm">chapter 25</a>. Thanks <a id="pageviii"></a>to everyone at Tor, especially the hardworking production department.</p>
<p class="indent">This book is the third and last in my “Still Life with Fascists” or “Small Change” series. The earlier volumes are <em>Farthing</em> (2006) and <em>Ha’penny</em> (2007). I’ve always been a very hopeful and optimistic person. That’s why I wrote these books.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781429954631_epub_ack_r1.vue?562886a0